import React, { Component } from 'react'
import { Modal, Form, Input, Checkbox, Select, Button } from 'antd'

const TYPES = [
  {
    label: 'Pdf', value: 'PDF'
  }, {
    label: 'Document', value: 'DOCUMENT'
  }, {
    label: 'Image', value: 'IMAGE'
  }, {
    label: 'Audio/Video', value: 'AUDIO_VIDEO'
  }, {
    label: 'Archive', value: 'ARCHIVE'
  }
]

const PROPERTIES = [
  {
    label: 'Can\'t be shared', value: 'CAN_NOT_BE_SHARED'
  }, {
    label: 'Can\'t be downloaded', value: 'CAN_NOT_BE_DOWNLOADED'
  }
]

class channelDirectorySmartCreateModal extends Component {
  state = {
    loading: false
  }

  handleOk = (e) => {
    const { id, createSmartDirectoryById, form: { validateFields } } = this.props

    e.preventDefault()

    validateFields((err, values) => {
      if (!err) {
        this.setState({
          loading: true
        })

        createSmartDirectoryById(id, {
          name: values.name,
          contentTypes: values.contentTypes,
          properties: values.properties,
          matchAllTagIds: values.matchAllTagIds,
          matchAnyTagIds: values.matchAnyTagIds,
          matchNoneTagIds: values.matchNoneTagIds
        }).then((response) => {
          this.setState({
            loading: false
          })
          this.handleCancel()
        })
      }
    })
  }

  handleCancel = (e) => {
    this.props.closeModal()
  }

  render () {
    const { loading } = this.state
    const { status, tags, form: { getFieldDecorator } } = this.props

    const layout = {
      labelCol: {
        md: { span: 10 }
      },
      wrapperCol: {
        md: { span: 14 }
      }
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Add Smart Folder'
        visible={status}
        onCancel={this.handleCancel}
        destroyOnClose
        width={440}
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='indigo' loading={loading} onClick={this.handleOk}>Add</Button>
        ]}
      >
        <Form onSubmit={this.handleOk} className='form'>
          <Form.Item {...layout} label='Folder Name'>
            {getFieldDecorator('name', {
              rules: [{ required: true,
                message: 'Please input folder name',
                max: 23,
                pattern: /^[^, ][ a-zA-Z_\\-\\.0-9]*/
              }]
            })(
              <Input name='name' maxLength={23} />
            )}
          </Form.Item>

          <Form.Item {...layout} label='File types'>
            {getFieldDecorator('contentTypes', {
            })(
              <Checkbox.Group options={TYPES} />
            )}
          </Form.Item>

          <Form.Item {...layout} label='File properties'>
            {getFieldDecorator('properties', {
            })(
              <Checkbox.Group options={PROPERTIES} />
            )}
          </Form.Item>

          <Form.Item {...layout} label='Match ALL tags'>
            {getFieldDecorator('matchAllTagIds', {
            })(
              <Select
                mode='multiple'
                placeholder='Select tags'
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
              </Select>
            )}
          </Form.Item>

          <Form.Item {...layout} label='Match ANY tags'>
            {getFieldDecorator('matchAnyTagIds', {
            })(
              <Select
                mode='multiple'
                placeholder='Select tags'
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
              </Select>
            )}
          </Form.Item>

          <Form.Item {...layout} label='Match NONE tags'>
            {getFieldDecorator('matchNoneTagIds', {
            })(
              <Select
                mode='multiple'
                placeholder='Select tags'
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
              </Select>
            )}
          </Form.Item>

        </Form>
      </Modal>
    )
  }
}

export default Form.create()(channelDirectorySmartCreateModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelDirectorySmartCreateModal/ChannelDirectorySmartCreateModal.jsx